
export enum CustomerCreditStatusCd {
	BANKRUPT = 'Bankrupt',
	CASH = 'Cash',
	CREDIT = 'Credit',
	NO_CREDIT = 'NoCredit',
	PAY_PLAN = 'PayPlan',
	VOLUNTARY = 'Voluntary'}
